"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTimecardOverride_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var UserTimecardOverride_Factory = /** @class */ (function () {
    function UserTimecardOverride_Factory() {
    }
    UserTimecardOverride_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            LastUpdatedBy: model.LastUpdatedBy,
            Notes: model.Notes,
            OverrideClockIn: Date_Factory_1.Date_Factory.CreateIncoming(model.OverrideClockIn),
            OverrideClockOut: Date_Factory_1.Date_Factory.CreateIncoming(model.OverrideClockOut),
            OverrideDate: Date_Factory_1.Date_Factory.CreateIncoming(model.OverrideDate, { ignoreTimePortion: true }),
            OverrideMinutes: model.OverrideMinutes,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            UserTimecardId: model.UserTimecardId,
        };
        return result;
    };
    UserTimecardOverride_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            LastUpdatedBy: model.LastUpdatedBy,
            Notes: model.Notes,
            OverrideClockIn: Date_Factory_1.Date_Factory.CreateOutgoing(model.OverrideClockIn),
            OverrideClockOut: Date_Factory_1.Date_Factory.CreateOutgoing(model.OverrideClockOut),
            OverrideDate: Date_Factory_1.Date_Factory.CreateOutgoing(model.OverrideDate, { ignoreTimePortion: true }),
            OverrideMinutes: model.OverrideMinutes,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            UserId: model.UserId,
            UserTimecardId: model.UserTimecardId,
        };
        return result;
    };
    return UserTimecardOverride_Factory;
}());
exports.UserTimecardOverride_Factory = UserTimecardOverride_Factory;
